import { SlidingWindowGuard } from './sliding-window-guard';

/** Erro compatível com o tratamento de respostas 429 que já existe nas telas. */
export class ClientRateLimitError extends Error {
    readonly status = 429;
    readonly code = 'ERR_CLIENT_RATE_LIMIT';
    readonly response = {
        status: 429,
        data: {
            message: 'Muitas ações em pouco tempo. Aguarde alguns segundos e tente novamente.',
        },
    };

    constructor(readonly retryAfterMs: number) {
        super('Muitas ações em pouco tempo.');
        this.name = 'ClientRateLimitError';
    }
}

/**
 * Barreira de UX para chamadas mutáveis feitas pela aplicação.
 * Não é uma fronteira de segurança: a mesma regra precisa existir na API.
 */
export class MutationRateGuard {
    private readonly guard: SlidingWindowGuard;

    constructor(now?: () => number) {
        this.guard = new SlidingWindowGuard(now, {
            maxEventsPerSecond: 12,
            maxEventsPerTenSeconds: 60,
            cooldownMs: 30_000,
        });
    }

    check(): void {
        const decision = this.guard.check();
        if (!decision.allowed) throw new ClientRateLimitError(decision.retryAfterMs);
    }
}

export const mutationRateGuard = new MutationRateGuard();
